<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">采购编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">采购商</span>
            <el-input
              v-model="listQuery.supplier"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">采购状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>

          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>

        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
        ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :highlightCurrentRow="true"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible">
      <FormComponent
        :id="activeId"
        :initFormData="initFormData"
        :fromFieldData="originFromFieldData"
        :dialogFormVisible="dialogFormVisible"
        :api="'purchase'"
        :isShowCloseBtn="false"
        :isShowSubmitBtn="false"
        :formDisabled="true"
        mode="approval"
      />
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'

import { reviewApprove, reviewReject } from '@/apis/Dictionary'
import { getPurchasePage } from '@/apis/Purchase'

import { ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/views/purchasManage/purchase/From.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from '@/views/purchasManage/purchase/FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'
import mixin from '@/mixins/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvalpurchas',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)

    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_PURCHASE,
      permissionName: permissionName.APPROVAL_PURCHASE,
      columnAllData: TableField.map(col => col.fieldKey === 'createTime' ? { ...col, fieldName: '申请时间', width: 160 } : col),

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        invoiceNo: undefined,
        invoiceCode: undefined,
        supplier: undefined,
        startTime: '',
        endTime: '',
        status: 0,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      submitLoading: false,
      statusOption: [],

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPurchasePage({ ...dataMap.listQuery, pageType: 2 }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((k: any) => {
              k.supplierAccount = k.supplierAccount || {}
              return {
                ...k,
                supplierAccountName: k.supplierAccount.name,
                supplierAccountType: k.supplierAccount.type,
                supplierAccountBranchName: k.supplierAccount.branchName,
                supplierAccount: k.supplierAccount.account
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          invoiceNo: undefined,
          invoiceCode: undefined,
          supplier: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: 0,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      getDropdownList() {
        dataMap.statusOption = [
          {
            id: 0,
            name: '待审核'
          }
        ]
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            ElMessageBox.prompt('请输入原因', '提示', {
              confirmButtonText: '提交',
              cancelButtonText: '取消',
              cancelButtonClass: 'el-button--danger'
            }).then(async(content: any) => {
              if (content.action === 'confirm') {
                await reviewReject('purchase', dataMap.activeId, { comment: content.value })
                dataMap.dialogFormVisible = false
                dataMap.getList()
                ElMessage.success('操作成功！')
              }
            })
          } else if (type === 'approve') {
            await reviewApprove('purchase', dataMap.activeId)
            dataMap.dialogFormVisible = false
            dataMap.getList()
            ElMessage.success('操作成功！')
          }
        } catch (err:any) {
          console.log(err, 'err')
        }
      }
    })
    const { mixinData } = mixin(dataMap)

    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
